import * as React from 'react';
import { Button } from '@sheinc/shelikes-design-system';
import './completeCheck.module.scss';

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onCompleteClick: () => any;
};

export class CompleteCheck extends React.Component<Props> {
  render() {
    const { onCompleteClick } = this.props;
    return (
      <div styleName="understanding-check">
        <div styleName="text">
          お疲れ様でした！
          <br />
          これでこのコースは完了です。
        </div>
        <div styleName="button-wrapper">
          <Button variant="primary" onClick={onCompleteClick} fullWidth={true}>
            このコースを完了する
          </Button>
        </div>
      </div>
    );
  }
}
